<template>
  <el-dialog
    title="选择客户"
    :visible.sync="visible"
    width="60%"
    :before-close="handleCancel"
    @open="handleOpen"
  >
    <div class="table-page-search-wrapper">
      <el-form :inline="true" :model="queryParam" class="demo-form-inline">
        <el-form-item label="客户名称">
          <el-input v-model="queryParam.supplier" placeholder="请输入客户名称" clearable></el-input>
        </el-form-item>
        <el-form-item label="电话">
          <el-input v-model="queryParam.telephone" placeholder="请输入电话" clearable></el-input>
        </el-form-item>
        <el-form-item label="联系人">
          <el-input v-model="queryParam.phonenum" placeholder="请输入联系人" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="searchQuery" :loading="loading">查询</el-button>
          <el-button @click="searchReset">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-table
      border
      ref="table"
      size="middle"
      row-key="id"
      :data="dataSource"
      :pagination="ipagination"
      :loading="loading"
      @selection-change="handleSelectionChange"
      @row-dblclick="handleRowDblclick"
    >
      <el-table-column type="selection" width="50" align="center"></el-table-column>
      <el-table-column type="index" label="#" width="60" align="center"></el-table-column>
      <el-table-column label="客户名称" prop="supplier" width="200"></el-table-column>
      <el-table-column label="联系人" prop="contacts" width="100"></el-table-column>
      <el-table-column label="电话" prop="telephone" width="130"></el-table-column>
      <el-table-column label="手机" prop="phoneNum" width="130"></el-table-column>
      <el-table-column label="邮箱" prop="email" width="180"></el-table-column>
      <el-table-column label="税率" prop="taxRate" width="80"></el-table-column>
      <el-table-column label="状态" prop="enabled" width="80" align="center">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.enabled" type="success">启用</el-tag>
          <el-tag v-else type="warning">禁用</el-tag>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="ipagination.current"
        :page-sizes="[10, 20, 30, 40, 50]"
        :page-size="ipagination.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="ipagination.total"
      ></el-pagination>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleCancel">取消</el-button>
      <el-button type="primary" @click="handleOk" :disabled="selectedRows.length === 0">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { vdsGetCustomerList } from '@/api/invoice'

export default {
  name: 'CustomerSelectModal',
  data() {
    return {
      visible: false,
      token: '',
      loading: false,
      selectedRows: [],
      queryParam: {
        supplier: '',
        telephone: '',
        phonenum: ''
      },
      ipagination: {
        current: 1,
        pageSize: 10,
        total: 0
      },
      dataSource: []
    }
  },
  methods: {
    show(token) {
      this.token = token
      this.visible = true
      this.selectedRows = []
      this.queryParam = {
        supplier: '',
        telephone: '',
        phonenum: ''
      }
      this.ipagination = {
        current: 1,
        pageSize: 10,
        total: 0
      }
      this.loadData(1)
    },
    handleCancel() {
      this.visible = false
    },
    handleOpen() {
      this.$nextTick(() => {
        this.$refs.table && this.$refs.table.clearSelection()
      })
    },
    handleSelectionChange(selection) {
      this.selectedRows = selection
    },
    handleRowDblclick(row) {
      this.selectedRows = [row]
      this.handleOk()
    },
    handleOk() {
      if (this.selectedRows.length === 0) {
        this.$message.warning('请选择客户')
        return
      }
      this.$emit('ok', this.selectedRows[0])
      this.visible = false
    },
    searchReset() {
      this.queryParam = {
        supplier: '',
        telephone: '',
        phonenum: ''
      }
      this.loadData(1)
    },
    loadData(page) {
      if (page) {
        this.ipagination.current = page
      }
      this.loading = true
      const params = {
        token: this.token,
        supplier: this.queryParam.supplier,
        telephone: this.queryParam.telephone,
        phonenum: this.queryParam.phonenum,
        page: this.ipagination.current,
        rows: this.ipagination.pageSize
      }
      vdsGetCustomerList(params).then((res) => {
        if (res.code == 0 && res.data) {
          let rows = res.data.rows || []
          rows = rows.map(row => {
            const newRow = { ...row }
            Object.keys(newRow).forEach(key => {
              if (typeof newRow[key] === 'object' && newRow[key] !== null && Object.keys(newRow[key]).length === 0) {
                newRow[key] = ''
              }
            })
            return newRow
          })
          this.dataSource = rows
          this.ipagination.total = res.data.total || 0
        }
      }).finally(() => {
        this.loading = false
      })
    },
    searchQuery() {
      this.loadData(1)
    },
    handleSizeChange(val) {
      this.ipagination.pageSize = val
      this.loadData()
    },
    handleCurrentChange(val) {
      this.ipagination.current = val
      this.loadData()
    }
  }
}
</script>

<style scoped>
.pagination {
  margin-top: 20px;
  text-align: right;
}
</style>
